import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MainLayout } from 'COMPONENTS/Layout';
import { connect } from 'react-redux';
import moment from 'moment';
import { addReportData, updateReportData, getSummary } from 'ACTIONS/reports.actions';
import ReportsTable from './ReportsTable';
import ReportsFilters from './ReportsFilters/ReportsFilters';
import Summary from './Summary/Summary';
import './ReportsPage.less';

const firstDayOfMonth = moment()
  .startOf('month')
  .format('YYYY-MM-DD');

const channel = 'campaigns';
class ReportsPage extends Component {
  componentDidMount() {
    window.Echo
      .channel(channel)
      .listen('CampaignCreated', ({ campaign }) => {
        this.props.addReportData(campaign);
      })
      .listen('CampaignUpdated', ({ campaign }) => {
        this.props.updateReportData(campaign);
      });
  }
  componentWillUnmount() {
    window.Echo.leave(channel);
  }
  render() {
    return (
      <MainLayout>
        <div className="report-page">
          <Summary getSummary={this.props.getSummary} />
          <div className="report-header">
            <h1 className="report-title">Reports for {moment(firstDayOfMonth).format('MMMM YYYY')}</h1>
          </div>
          <ReportsFilters currentMonthDate={firstDayOfMonth} />
          <ReportsTable currentMonthDate={firstDayOfMonth} />
        </div>
      </MainLayout>
    );
  }
}

ReportsPage.propTypes = {
  addReportData: PropTypes.func.isRequired,
  updateReportData: PropTypes.func.isRequired,
  getSummary: PropTypes.func.isRequired,
};

export { ReportsPage as PureReportsPage };
export default connect(null, { addReportData, updateReportData, getSummary })(ReportsPage);



// WEBPACK FOOTER //
// ./src/pages/Reports/ReportsPage.js